module.exports = __webpack_public_path__ + "media/images/lp_consultation/mv-device-large-e91859d32f5b5bf3e0ec11df5ec74a8a.jpg";